import axios from "axios";

/**
 * Client-side axios instance. Always same-origin (relative /api/* paths hitting our own
 * Next.js API routes, never Laravel directly), so the browser's httpOnly auth cookie is sent
 * automatically by the browser with no manual header wiring needed here.
 *
 * Components/pages should never call this directly -- go through a services/*Service.js
 * module instead, so API shape knowledge stays out of the UI layer.
 */
const apiClient = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Normalizes an axios error into a plain, user-safe message string, matching the shape our
 * own /api/* routes return ({ message, errors }).
 */
export function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    "Something went wrong. Please try again."
  );
}

/**
 * Normalizes Laravel validation errors (a { field: [messages] } map) forwarded through our
 * BFF routes into a flat { field: message } shape react-hook-form's setError can consume.
 */
export function getFieldErrors(error) {
  const errors = error?.response?.data?.errors?.errors || error?.response?.data?.errors;
  if (!errors || typeof errors !== "object") return null;

  return Object.fromEntries(
    Object.entries(errors)
      .filter(([key]) => key !== "error_message")
      .map(([key, messages]) => [key, Array.isArray(messages) ? messages[0] : messages])
  );
}

export default apiClient;
